import { Reveal, RevealLineOnScroll } from "./Reveal";
import { useModal } from "../context/ModalContext";

export const CTA = () => {
  const { openContact, openWaitlist } = useModal();
  return (
    <section
      data-testid="cta-section"
      className="bg-white text-black pt-16 md:pt-20 pb-10 md:pb-12 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          className="relative overflow-hidden rounded-3xl border bg-[#f5f5f7] px-6 py-12 md:py-16 text-center"
          style={{ borderColor: "var(--border-light)" }}
        >
          <div
            className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full opacity-[0.06] blur-[130px]"
            style={{ background: "var(--primary-accent)" }}
          />
          <div className="relative z-10">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
                Ready to launch?
              </p>
            </Reveal>
            {/* <h2 className="font-display text-black text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tighter leading-[0.98] max-w-3xl mx-auto">
              <RevealLineOnScroll>Bring self-custody</RevealLineOnScroll>
              <RevealLineOnScroll delay={0.08}>payments to cards.</RevealLineOnScroll>
            </h2> */}

            <Reveal delay={0.3}>
              <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                <button
                  data-testid="cta-contact-btn"
                  onClick={openContact}
                  className="rounded-full bg-black text-white text-sm font-semibold px-8 py-4 hover:scale-105 transition-transform duration-300"
                >
                  Contact Sales
                </button>
                <button
                  data-testid="cta-waitlist-btn"
                  onClick={openWaitlist}
                  className="rounded-full border bg-white text-black text-sm font-semibold px-8 py-4 hover:bg-black/[0.03] transition-colors duration-300"
                  style={{ borderColor: "var(--border-light)" }}
                >
                  Join the Waitlist
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
